import { JSX } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import Button from "@/components/buttons/Button.tsx";
import Input from "@/components/inputs/Input.tsx";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { useResetOtp } from "@/hooks/api/login.hooks";
import useModalRouter from "@/hooks/useModalRouter";

import { ForgotPasswordForm } from "./types";

const ForgotPasswordLogin = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormContext<ForgotPasswordForm>();
  const { mutate: mutateSendCode, isPending } = useResetOtp();

  const { closeModal, openModal } = useModalRouter();

  const onSubmit = (data: ForgotPasswordForm): void => {
    mutateSendCode(data.login, {
      onSuccess(res) {
        openModal([MODAL_ROUTES.FORGOT_PASSWORD, MODAL_ROUTES.FORGOT_PASSWORD_CODE], {
          username: data.login,
          account_id: res.data!.account_id.toString(),
        });
      },
      onError(error: any) {
        const message = error.response.data.message;

        toast(message ?? t("error.something-wrong"), { type: "error", theme: "dark" });
      },
    });
  };

  return (
    <>
      <div className={"staff-modal__header mb-8"}>
        <h2 className={"staff-modal__title text-center"}>{t("General.forgot-password").split("?")}?</h2>
        <p className={"staff-modal__description max-w-96 text-center"}>{t("General.forgot-password-message")}</p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className={"w-full space-y-10"}>
        <Input
          type={"text"}
          color={"white"}
          placeholder={t("edition-login-message")}
          name={"login"}
          register={register}
          validation={{
            required: true,
          }}
          errors={errors}
        />
        <div className={"space-y-4"}>
          <Button type={"submit"} isLoading={isPending} title={t("Actions.continue")}>
            {t("Actions.continue")}
          </Button>
          <Button type={"button"} title={t("Actions.cancel")} onClick={closeModal} color={"black"} className={"w-full"}>
            {t("Actions.cancel")}
          </Button>
        </div>
      </form>
    </>
  );
};

export default ForgotPasswordLogin;
